var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#1C3C54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2609 10.9286H8.73913C8.06174 10.9286 7.5 10.3781 7.5 9.71429C7.5 9.05048 8.06174 8.5 8.73913 8.5H25.2609C25.9383 8.5 26.5 9.05048 26.5 9.71429C26.5 10.3781 25.9383 10.9286 25.2609 10.9286ZM25.2609 18.2143H8.73913C8.06174 18.2143 7.5 17.6638 7.5 17C7.5 16.3362 8.06174 15.7857 8.73913 15.7857H25.2609C25.9383 15.7857 26.5 16.3362 26.5 17C26.5 17.6638 25.9383 18.2143 25.2609 18.2143ZM25.2609 25.5H8.73913C8.06174 25.5 7.5 24.9495 7.5 24.2857C7.5 23.6219 8.06174 23.0714 8.73913 23.0714H25.2609C25.9383 23.0714 26.5 23.6219 26.5 24.2857C26.5 24.9495 25.9383 25.5 25.2609 25.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.cba980bf161dea7f429781b52e1db4a7.svg";
export { ForwardRef as ReactComponent };